import { MATCH_FLOWS } from './constants';
import { MatchFlow } from './matchFlow';

const BaseStorageShowOperations = {
  setShow(value) {
    localStorage.setItem(this.storageKey, value);
  },
};

const UpdateConditionalProfileDialog = {
  storageKey: 'show_update_medical_condition_dialog',
  ...BaseStorageShowOperations,
};

export const LatestMatchesFlow = {
  onLogin() {
    MatchFlow.setMatchFlow(MATCH_FLOWS.LATEST);
    UpdateConditionalProfileDialog.setShow(true);
  },
  onUpdateMedicalCondition() {
    MatchFlow.setMatchFlow(MATCH_FLOWS.BASIC);
    UpdateConditionalProfileDialog.setShow(false);
  },
  onQuestionnairePass() {
    MatchFlow.setMatchFlow(MATCH_FLOWS.BASIC);
    UpdateConditionalProfileDialog.setShow(false);
  },
};
